export enum KYC_RESPONSE_STATUS {
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    BLOCKED = 'BLOCKED',
    CREATED = 'CREATED',
    MISMATCH_DETECTED = 'MISMATCH_DETECTED',
}

export enum VOLT_KYC_ERROR_CODE {
    USER_AUTH_CANCELLED = 'USER_AUTH_CANCELLED',
    USER_CONSENT_DENIED = 'USER_CONSENT_DENIED',
    KYC_NOT_INITIATED = 'KYC_NOT_INITIATED',
    INSUFFICIENT_SCOPE = 'INSUFFICIENT_SCOPE',
    KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO = 'KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO',
    AGE_BELOW_LIMIT = 'AGE_BELOW_LIMIT',
    AGE_ABOVE_LIMIT = 'AGE_ABOVE_LIMIT',
    DIGIO_PAN_MISMATCH = 'DIGIO_PAN_MISMATCH',
    MISMATCH_DETECTED = 'MISMATCH_DETECTED',
    CREATED = 'CREATED'
}

export const KYC_ERROR_MAP: Record<string, { failedTitle: string; failedSubTitle: string; failedButtonTitle: string }> = {
    [VOLT_KYC_ERROR_CODE.KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO]: {
        failedTitle: "Verification failed!",
        failedSubTitle: "Name mismatch detected. Please check your documents and try again.",
        failedButtonTitle: "Try again",
    },
    [VOLT_KYC_ERROR_CODE.DIGIO_PAN_MISMATCH]: {
        failedTitle: "Verification failed!",
        failedSubTitle: "PAN card number not matching with account details. Kindly check the document and try again.",
        failedButtonTitle: "Try again",
    },
    [VOLT_KYC_ERROR_CODE.MISMATCH_DETECTED]: {
        failedTitle: "PAN is not linked with the provided Aadhaar",
        failedSubTitle: "Please ensure your PAN is linked with Aadhaar and try again.",
        failedButtonTitle: "Try again",
    },
    [VOLT_KYC_ERROR_CODE.CREATED]: {
        failedTitle: "KYC verification canceled",
        failedSubTitle: "KYC verification is required for the completion of your loan application",
        failedButtonTitle: "Try again",
    },
    [VOLT_KYC_ERROR_CODE.USER_AUTH_CANCELLED]: {
        failedTitle: 'KYC Verification cancelled',
        failedSubTitle: 'KYC verification is required for the completion of your loan application.',
        failedButtonTitle: 'Try again',
    },
    [VOLT_KYC_ERROR_CODE.USER_CONSENT_DENIED]: {
        failedTitle: 'Verification failed!',
        failedSubTitle: 'Please allow consent to complete your application.',
        failedButtonTitle: 'Try again',
    },
    [VOLT_KYC_ERROR_CODE.KYC_NOT_INITIATED]: {
        failedTitle: 'Verification failed!',
        failedSubTitle: 'Please allow consent to complete your application.',
        failedButtonTitle: 'Try again',
    },
    [VOLT_KYC_ERROR_CODE.INSUFFICIENT_SCOPE]: {
        failedTitle: 'Verification failed!',
        failedSubTitle: 'Please allow consent to complete your application.',
        failedButtonTitle: 'Try again',
    },
    [VOLT_KYC_ERROR_CODE.AGE_BELOW_LIMIT]: {
        failedTitle: 'Minimum age requirement not met',
        failedSubTitle: '', // You can set this dynamically if needed
        failedButtonTitle: 'Ok, got it.',
    },
    [VOLT_KYC_ERROR_CODE.AGE_ABOVE_LIMIT]: {
        failedTitle: 'Age eligibility criteria not met',
        failedSubTitle: '', // You can set this dynamically if needed
        failedButtonTitle: 'Ok, got it.',
    },
    DEFAULT: {
        failedTitle: "Verification failed!",
        failedSubTitle: "Something went wrong. Please try again.",
        failedButtonTitle: "Try again",
    },
};
